import { useQuery, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import useAuthStore from '../../store/authStore';
import {
  getFeaturedCategories,
  getFeaturedCategoryById,
  createFeaturedCategory,
  updateFeaturedCategory,
  deleteFeaturedCategory
} from '../../api/admin/adminFeaturedCategoriesApi';

export const useFeaturedCategories = (query = {}) => {
  const { user } = useAuthStore();
  return useQuery(['featured-categories', query], () => getFeaturedCategories(query), {
    enabled: !!user,
    staleTime: 300000,
    cacheTime: 3600000,
  });
};

export const useFeaturedCategory = (id) => {
  const { user } = useAuthStore();
  return useQuery(['featured-category', id], () => getFeaturedCategoryById(id), {
    enabled: !!user && !!id,
  });
};

export const useCreateFeaturedCategory = () => {
  const queryClient = useQueryClient();
  return useMutation(createFeaturedCategory, {
    onSuccess: () => {
      toast.success('Featured category created');
      queryClient.invalidateQueries('featured-categories');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to create');
    }
  });
};

export const useUpdateFeaturedCategory = () => {
  const queryClient = useQueryClient();
  return useMutation(updateFeaturedCategory, {
    onSuccess: () => {
      toast.success('Featured category updated');
      queryClient.invalidateQueries('featured-categories');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update');
    }
  });
};

export const useDeleteFeaturedCategory = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteFeaturedCategory, {
    onSuccess: () => {
      toast.success('Featured category deleted');
      queryClient.invalidateQueries('featured-categories');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete');
    }
  });
};